import { render, staticRenderFns } from "./TrSelectGameWithTextImprV2.vue?vue&type=template&id=00f2b1c5&scoped=true&"
import script from "./TrSelectGameWithTextImprV2.vue?vue&type=script&lang=js&"
export * from "./TrSelectGameWithTextImprV2.vue?vue&type=script&lang=js&"
import style0 from "./TrSelectGameWithTextImprV2.vue?vue&type=style&index=0&id=00f2b1c5&lang=scss&scoped=true&"
import style1 from "./TrSelectGameWithTextImprV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f2b1c5",
  null
  
)

export default component.exports